<h2 fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px" style="margin-bottom: 0">
  <span>
    <span *ngIf="!title">Netzanmeldung</span>
    <span *ngIf="title">{{ title }}</span>
    <span *ngIf="id">(id:{{ id }})</span>
  </span>
  <div
    *ngIf="state"
    class="progress"
    [style.background-color]="state | requestStatusNameAndCss : 'css'"
    style="padding: 0 1em; height: 40px">
    <div style="line-height: 40px">
      <span *ngIf="!statusFeedInManagementLoop">
        {{ state | requestStatusNameAndCss : 'name' }}
      </span>
      <span *ngIf="statusFeedInManagementLoop">
        {{ statusFeedInManagementLoop }}
      </span>
    </div>
  </div>
</h2>
